import { __decorate } from "tslib";
import { LitElement, html } from 'lit';
import { property } from 'lit/decorators.js';
import infoCircleIcon from '../../assets/icons/info-circle';
import checkCircleIcon from '../../assets/icons/check-circle';
import exclamationCircleIcon from '../../assets/icons/exclamation-circle';
import exclamationTriangleIcon from '../../assets/icons/exclamation-triangle';
import '../icon';
import '../typography/tg-body-two';
import styles from './styles';
const variantToIconMap = {
    success: checkCircleIcon,
    error: exclamationCircleIcon,
    caution: exclamationTriangleIcon,
    info: infoCircleIcon,
};
/**
 * @dependency amityeko-icon
 * @dependency amityeko-tg-body-two
 *
 * @slot - Content of the inline message.
 */
export default class AmityekoInlineMessage extends LitElement {
    constructor() {
        super(...arguments);
        this.variant = 'info';
        this.hasCustomIcon = false;
    }
    render() {
        const iconSvg = variantToIconMap[this.variant];
        return html `
      <div variant=${this.variant} class="message">
        ${this.hasCustomIcon
            ? html `<slot name="custom-icon"></slot>`
            : html `<amityeko-icon .iconSize=${'20px'} class="message__icon"
              >${iconSvg}</amityeko-icon
            >`}
        <amityeko-tg-body-two class="message__text"><slot></slot></amityeko-tg-body-two>
      </div>
    `;
    }
}
AmityekoInlineMessage.styles = styles;
__decorate([
    property()
], AmityekoInlineMessage.prototype, "variant", void 0);
__decorate([
    property({ type: Boolean })
], AmityekoInlineMessage.prototype, "hasCustomIcon", void 0);
if (!customElements.get('amityeko-inline-message')) {
    customElements.define('amityeko-inline-message', AmityekoInlineMessage);
}
//# sourceMappingURL=index.js.map